import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const carouselMiniCardsSettingsFn = /* @__PURE__ */ createRecipe('carousel-mini-cards-settings', {}, [])

const carouselMiniCardsSettingsVariantMap = {}

const carouselMiniCardsSettingsVariantKeys = Object.keys(carouselMiniCardsSettingsVariantMap)

export const carouselMiniCardsSettings = /* @__PURE__ */ Object.assign(memo(carouselMiniCardsSettingsFn.recipeFn), {
  __recipe__: true,
  __name__: 'carouselMiniCardsSettings',
  __getCompoundVariantCss__: carouselMiniCardsSettingsFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: carouselMiniCardsSettingsVariantKeys,
  variantMap: carouselMiniCardsSettingsVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, carouselMiniCardsSettingsVariantKeys)
  },
  getVariantProps: carouselMiniCardsSettingsFn.getVariantProps,
})